/**
 * src/components/AnnouncementBar.jsx
 * Edit MESSAGES directly to change what rotates through the top bar.
 */
import { useEffect, useState } from "react";

const MESSAGES = [
  "🎉 5% OFF on your first order | Call 98738 04717",
  "🚚 One day delivery in Gurgaon | Free shipping on prepaid orders",
];

const ROTATE_MS = 4000;

export function AnnouncementBar() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % MESSAGES.length);
    }, ROTATE_MS);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="announcement-bar">
      <span key={index} className="announcement-bar-text">
        {MESSAGES[index]}
      </span>
    </div>
  );
}